import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "df" }
const _hoisted_2 = ["href"]
const _hoisted_3 = {
  key: 1,
  class: "df__icon"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = {
  key: 3,
  class: "df__label"
}
const _hoisted_6 = {
  key: 4,
  class: "df__button"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.href)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: _ctx.href,
          target: "_blank",
          class: "df__icon",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onDownloadClick && _ctx.onDownloadClick(...args)))
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(_ctx.icon)
          }, null, 2)
        ], 8, _hoisted_2))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("i", {
            class: _normalizeClass(_ctx.icon)
          }, null, 2)
        ])),
    (_ctx.href)
      ? (_openBlock(), _createElementBlock("a", {
          key: 2,
          href: _ctx.href,
          class: "df__label",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onDownloadClick && _ctx.onDownloadClick(...args)))
        }, _toDisplayString(_ctx.getFileName), 9, _hoisted_4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.getFileName), 1)),
    (_ctx.$slots.button)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "button")
        ]))
      : _createCommentVNode("", true)
  ]))
}